// @ts-nocheck
/* global css */
import React, { useState, ChangeEvent, useEffect } from 'react';
import { ClassificationValue, Classification } from '@fulcrumapp/fulcrum-core';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';
import flattenClassifications from './helpers/flatten-classifications';

interface Props {
  classificationItems: Classification[],
  value?: ClassificationValue,
  onChange?: (newVal: ClassificationValue) => void,
  allowOtherValue?: boolean,
  disabled?: boolean,
}

const OTHER_VALUE = '__OTHER__';

/**
 * @deprecated this field has been replaced by the MUI classificationset-field.tsx
 */
const ClassificationsetField: React.FC<Props> = ({
  classificationItems,
  value = new ClassificationValue(),
  onChange = () => {},
  allowOtherValue = false,
  disabled = false,
}: Props) => {
  const [selectedValue, setSelectedValue] = useState(value);
  const [otherValue, setOtherValue] = useState(value.otherValue || '');
  const [otherSelected, setOtherSelected] = useState(allowOtherValue && value.hasOtherValue);

  const handleOtherValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;

    const newValue = selectedValue;
    const newOtherValue = event.target.value;

    newValue.otherValue = newOtherValue;

    setOtherValue(newOtherValue);
    setSelectedValue(newValue);

    onChange(newValue);
  };

  const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    if (disabled) return;

    const values = [];
    if (event.target.value.length) {
      const selection = JSON.parse(event.target.value);
      values.push(...selection);
    }

    const isOtherSelectedNow = values.includes(OTHER_VALUE);
    setOtherSelected(isOtherSelectedNow);

    const selectedValues = values.filter((v) => (v !== OTHER_VALUE));

    // Remove empty or falsey values from the other field
    const filteredOtherValue = isOtherSelectedNow ? [otherValue].filter(Boolean)[0] : null;

    selectedValue.setSelectedClassificationJSON(selectedValues, filteredOtherValue);

    setSelectedValue(selectedValue);
    onChange(selectedValue);
  };

  const stringifiedValue = (): string => {
    const values = value.selectedClassification ? value.selectedClassification.toJSON() : [];

    if (otherSelected) {
      values.push(OTHER_VALUE);
    }

    if (values.length) {
      return JSON.stringify(values);
    }

    return '';
  };

  useEffect(() => {
    setSelectedValue(value || new ClassificationValue());
  }, [value]);

  useEffect(() => {
    setOtherValue(otherValue || '');
  }, [otherValue]);

  return (
    <div>
      <select
        value={stringifiedValue()}
        onChange={handleSelectChange}
        disabled={disabled}
        className={css(styles.select)}
      >
        {flattenClassifications(classificationItems, allowOtherValue, 'items').map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
          >
            {opt.label}
          </option>
        ))}
      </select>
      {allowOtherValue && otherSelected && (
        <input
          type="text"
          value={otherValue}
          onChange={handleOtherValueChange}
          disabled={disabled}
          className={css(styles.otherValue)}
          placeholder="Enter Other Value"
        />
      )}
    </div>
  );
};

const styles: {otherValue: string, select: string} = cssInJS({
  otherValue: {
    fontSize: THEME.editFontSize,
    border: '1px solid #d9d9d9',
    padding: 4,
    width: '100%',
    borderRadius: 5,
    marginBottom: 4,
  },

  select: {
    fontFamily: THEME.fontFamily,
    fontSize: THEME.editFontSize,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    display: 'inline-block',
    padding: 5,
    verticalAlign: 'middle',
    borderRadius: 5,
    width: '100%',
    marginTop: 4,
    marginRight: 0,
    marginBottom: 4,
    marginLeft: 0,

    '@phone': {
      width: '100%',
    },
  },
});

export default ClassificationsetField;
